/**
 * Nhãn thay tên nhà cung cấp riêng tư trên chứng từ, khi người xem không được thấy nhà cung cấp đó (Roary 09/10/2026, YC-02; anh
 * Toàn chốt 28/10/2026, phương án "vẫn thấy chứng từ, tên là Nhà cung cấp nội bộ" — kho vẫn nhận được hàng).
 *
 * Máy chủ thay tên ở MỘT cửa (`requireAuth` → `supplierMask-logic.ts`); giao diện dịch nhãn này ở MỘT cửa (`apiFetch`) bằng khoá
 * `common.internalSupplier`. Đi ngược lại, máy chủ từ chối mọi lần ghi mang nhãn này hoặc bản dịch của nó
 * (`INTERNAL_SUPPLIER_LABELS`) — không thì lưu lại một chứng từ đã che là ghi đè tên thật bằng chữ "Nhà cung cấp nội bộ".
 */
export const INTERNAL_SUPPLIER = "internal_supplier";

/** Bản dịch của nhãn — PHẢI khớp khoá `common.internalSupplier` của ba ngôn ngữ giao diện (bài kiểm i18n khoá điều này). */
export const INTERNAL_SUPPLIER_LABELS = {
  vi: "Nhà cung cấp nội bộ",
  en: "Internal supplier",
  "zh-Hans": "内部供应商",
} as const;

export function isInternalSupplier(label: string | null | undefined): boolean {
  return label === INTERNAL_SUPPLIER;
}
